import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const GalleryLightbox = ({ images, index, onClose, onNavigate }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onNavigate(-1);
      if (e.key === 'ArrowRight') onNavigate(1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, onNavigate]);

  if (index === null || !images?.length) return null;

  const img = images[index];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
      <button
        type="button"
        onClick={onClose}
        aria-label={t('explore.galleryLightbox.close')}
        className="absolute right-6 top-6 text-2xl text-white"
      >
        ✕
      </button>
      <button
        type="button"
        onClick={() => onNavigate(-1)}
        aria-label={t('explore.galleryLightbox.previous')}
        className="absolute left-4 top-1/2 -translate-y-1/2 rounded-full bg-zinc-100 dark:bg-zinc-800/80 px-4 py-2 text-white"
      >
        ‹
      </button>
      <img src={img.imageUrl} alt={img.caption || ''} className="max-h-[85vh] max-w-full rounded-lg object-contain" />
      <button
        type="button"
        onClick={() => onNavigate(1)}
        aria-label={t('explore.galleryLightbox.next')}
        className="absolute right-4 top-1/2 -translate-y-1/2 rounded-full bg-zinc-100 dark:bg-zinc-800/80 px-4 py-2 text-white"
      >
        ›
      </button>
      {img.caption && <p className="absolute bottom-8 text-sm text-zinc-700 dark:text-zinc-300">{img.caption}</p>}
    </div>
  );
};

export default GalleryLightbox;
